import React, { useState } from "react";

import Button from "./Button";
import TextInput from "./TextInput";
import { PageHeader } from "../Typo/PageHeader";
import { StyledLogin } from "../Styles/StyledLogin";

interface LoginProps {
  onClick?: () => void;
}

const Login = ({onClick}: LoginProps) => {
  const [password, setPassword] = useState({ value: "", error: "" });

  return (
    <StyledLogin
      onSubmit={(e) => {
        e.preventDefault();

        if(password.value === "1234") {
          localStorage.setItem("isLoggedIn", "true");
          onClick?.();
          window.location.reload();
        }else {
          setPassword((prev) => ({ value: prev.value, error: "Chybné heslo" }));
        }


      }}>
      <PageHeader>Přihlásit se</PageHeader>
      <TextInput
        error={password.error}
        label='Heslo'
        name='password'
        id={"password"}
        onChange={(e) => setPassword({ value: e.target.value, error: "" })}
        value={password.value}
        type={`password`}
      />
      <Button type={`submit`} className='primary'>
        login
      </Button>
    </StyledLogin>
  );
};

export default Login;
